import { createContext } from 'react';
import { ChapterType } from '../types';

export interface CourseContextInterface {
  currentChapter: ChapterType;
  currentChapterId?: number;
  chapterContent: string;
}

export default createContext<CourseContextInterface>({
  currentChapter: {
    id: undefined,
    isCompleted: false,
    type: '',
    title: '',
    parentId: undefined,
  },
  chapterContent: '',
  currentChapterId: undefined,
});
